<template>
  <div class="container">
    <div
        class="flex justify-center flex-wrap items-center flex-col text-center"
    >
      <img src="@/assets/images/all-img/access-denied.png" alt=""/>
      <h4 class="text-3xl font-medium text-slate-900 dark:text-white mb-2">
        permission denied
      </h4>
      <p class="font-normal text-base text-slate-500 dark:text-slate-300">
       you don't have permission to access this url <br/>
        Call with admin
      </p>
    </div>
  </div>
</template>
<script>
import Button from "@/components/Button/index.vue";
import Icon from "@/components/Icon/index.vue";
import {useThemeSettingsStore} from "@/stores/themeSettings.js";

export default {
  components: {
    Button,
    Icon,
  },
  setup() {
    const themeSettingsStore = useThemeSettingsStore()
    return {
      themeSettingsStore
    }
  }
};
</script>
<style lang="scss" scoped>
.social-link {
  @apply h-8 w-8 flex flex-col items-center justify-center border-black-500 dark:border-slate-700 border rounded-full text-slate-900 dark:text-slate-300 leading-[1] hover:bg-slate-900 dark:hover:bg-slate-700 hover:text-white transition duration-150;
}
</style>
